import { createContext } from "react";

const RouteContext = createContext({
	params: {},
});

export default RouteContext;
